import { type ComponentProps, useBlockNoteEditor } from "@blocknote/react";
import { useState } from "react";

type Props = ComponentProps["Generic"]["Menu"]["Trigger"];

export function Trigger({ children, sub }: Props) {
  const [open, setOpen] = useState(false);
  const editor = useBlockNoteEditor();

  const onClick = () => {
    setOpen(!open);
    if (!open) {
      editor?.sideMenu.freezeMenu();
    } else if (open && !sub) {
      editor?.sideMenu.unfreezeMenu();
    }
  };

  return (
    <div data-menu-open={open} onClick={onClick}>
      {children}
    </div>
  );
}
